import dayjs from 'dayjs';
import React from 'react';
import {Link} from 'react-router-dom';
import {getPortalInfo} from '../../shared/utils';
import classes from './Home.module.scss';

const NEWS = [
    {
        date: '2020-03-30',
        content: 'Partners portal launched'
    },
    {
        date: '2020-04-01',
        content: 'Pricing updated for April'
    },
    {
        date: '2020-04-02',
        content: 'Added all presentations for viewing and download'
    },
    {
        date: '2020-06-25',
        content: 'Added AIDA legal presentation'
    },
    {
        date: '2020-08-13',
        content: 'Added AIDA HR presentation'
    },
    {
        date: '2020-09-04',
        content: 'Pricing updated according to September 2020 listings'
    },
    {
        date: '2020-12-02',
        content: 'Added AIDA/Xerox Delivery Services presentation'
    },
    {
        date: '2021-01-07',
        content: 'Pricing updated for January 2021'
    },
    {
        date: '2021-06-11',
        content: 'Promotions section added'
    },
    {
        date: '2021-08-12',
        content: 'Added customers section'
    },
    {
        date: '2021-11-12',
        content: 'End of 2021 promotions added'
    },
    {
        date: '2022-01-18',
        content: 'Pricing updated for January 2022'
    },
    {
        date: '2022-04-28',
        content: 'New partner promotions (Q2 2022) added'
    },
    {
        date: '2022-11-02',
        content: 'New partner promotions (end 2022) added'
    },
    {
        date: '2023-01-13',
        content: <>
            <p>Pricing updated for January 2023</p>
            <h6>Major updates</h6>
            <ul>
                <li>Partner discounts have been increased for all levels, from 10/15/20/25% to 20/30/40/60%</li>
                <li>AIDA entry-level plan price has been decreased by 13.9%</li>
                <li>Price for other plans has been decreased by 13%, on average</li>
                <li>Fax option has been removed</li>
            </ul>
            <p>Each partner will soon receive an e-mail with all the details about the changes.</p>
        </>
    },
    {
        date: '2023-02-15',
        content: 'New partner promotions (Q1 2023) added'
    },
    {
        date: '2023-08-22',
        content: 'New english presentations'
    },
    {
        date: '2023-10-02',
        content: 'New partner promotions (Q4 2023) added'
    },
    {
        date: '2023-11-17',
        content: <>
            For more information on rules concerning contracts renewal and upgrades, <Link to="/renewals">check the
                                                                                                         available
                                                                                                          options</Link> and
            the related legal terms.
        </>
    },
    {
        date: '2023-12-05',
        content: <>
            AIDA brochure (english) has been added: <Link to="/presentation/aida-brochure-en">check it out</Link>
        </>
    },
    {
        date: '2024-02-01',
        content: 'Pricing updated for February 2024'
    },
    {
        date: '2025-01-20',
        content: <>
            <p>Pricing updated for January 2025</p>
            <h6>Levels and options updates:</h6>
            <ul>
                <li>AIDA Business: 4.800 pages (was 6.000 Enterprise Plus) - 5-year commitment, no partner discounts
                </li>
                <li>AIDA Business Plus: 9.600 pages (was 10.000 Enterprise Plus) - 3-year commitment, no partner
                    discounts
                </li>
                <li>AIDA Enterprise: 19.600 pages (was 20.000 Enterprise Plus) - 2-year commitment, no partner
                    discounts
                </li>
                <li>Discontinued: 1.500 and 3.600 pages levels</li>
                <li>New: Professional Pages available as standalone</li>
                <li>Removed: AIDA/DocuShare bundle option</li>
            </ul>
        </>
    },
    {
        date: '2025-04-02',
        content: <>
            <p>Pricing updated for Q2 2025:</p>
            <ul>
                <li>Pricing in USD currency has been increased by 5%</li>
                <li>All others prices are unchanged</li>
            </ul>
        </>
    },
    {
        date: '2025-07-03',
        content: <>
            <p>Pricing updated for Q3 2025:</p>
            <ul>
                <li>Pricing in USD currency has been increased accordingly to adjusted EUR/USD exchange rate</li>
                <li>All others prices are unchanged</li>
            </ul>
        </>
    },
    {
        date: '2026-01-13',
        content: <>
            <p>Pricing updated for 2026</p>
        </>
    },
    {
        date: '2026-04-14',
        content: <>
            <p>All partner material has been refreshed: new <Link to="/presentation/presentation-en">presentations</Link> (EN/FR/IT),{' '}
                <Link to="/presentation/case-studies-en">case studies</Link> (EN/FR/IT), flyers, and qualification questionnaires are now available
                from the Presentations menu.</p>
        </>
    },
    {
        date: '2026-07-02',
        content: <>
            <p>Pricing updated for July 2026:</p>
            <ul>
                <li>AIDA Business Plus is now called AIDA Business</li>
                <li>Discontinued: 4.800 pages level</li>
            </ul>
        </>
    },
    {
        date: '2026-08-25',
        content: <>
            <p>More flexibility for AIDA orders and renewals:</p>
            <ul>
                <li>Partners can now choose the contract duration that best fits each customer, from 1 to 5 years,
                    across all AIDA plans
                </li>
                <li>Renewal and upgrade options have been streamlined around their outcome, making the right choice
                    clearer and easier
                </li>
            </ul>
            <p>Review the <Link to="/renewals">updated renewal and upgrade options</Link> or <Link to="/order">create an
                order</Link>.</p>
        </>
    },
];

const Home = () => {
    const printNews = ({ date, content }, index) => {
        return <div className={classes.News} key={`news-${index}`}>
            <div className={classes.Date}>
                {dayjs(date).format('DD MMM YYYY')}
            </div>
            <div className={classes.Content}>{content}</div>
        </div>;
    };

    return (
        <div className="container">
            <h1>{getPortalInfo().documentTitle}</h1>

            {/*<div className="columns">
                <div className="column">
                    <Link to="/promotions" className={clsx('card', classes.Promotions)}>
                        <div className={classes.Header}>
                            <p className="card-header-title">
                                <Icon name={[ 'fad', 'badge-dollar' ]} />
                                Promotions
                            </p>
                        </div>
                        <div className={clsx('card-content', classes.Content)}>
                            <div className="content">Promotions for partners</div>
                        </div>
                    </Link>
                </div>
                <div className="column">
                    <Link to="/presentation" className={clsx('card', classes.Presentations)}>
                        <div className={classes.Header}>
                            <p className="card-header-title">
                                <Icon name="presentation" />
                                Presentations
                            </p>
                        </div>
                        <div className={clsx('card-content', classes.Content)}>
                            <div className="content">AIDA and AIDA/DocuShare bundle presentations for viewing and
                                download
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="column">
                    <Link to="/order" className={clsx('card', classes.Order)}>
                        <div className={classes.Header}>
                            <p className="card-header-title">
                                <Icon name="file-contract"/>
                                Order form
                            </p>
                        </div>
                        <div className={clsx('card-content', classes.Content)}>
                            <div className="content">AIDA and AIDA/DocuShare bundle order module with total and annual
                                                     TCO summary
                            </div>
                        </div>
                    </Link>
                </div>
            </div>*/}

            <p>Welcome to the AIDA partners portal.</p>

            {/*<h3>Promotions&nbsp;&nbsp;&nbsp;<Icon name="bell-on" color="red" /></h3>
            <article className="message is-primary">
                <div className="message-body">Special promotions for partners for end of 2021 are active, <Link
                    to="/promotions">check them on the dedicated page</Link>.
                </div>
            </article>*/}

            <h3>News</h3>
            {NEWS.sort((n1, n2) => n1.date > n2.date ? -1 : 1).map((news, i) => printNews(news, i))}
        </div>
    );
};

export default Home;
